import {Component, ViewChild} from '@angular/core';
import {TarefaService} from "../../../services/tarefa-service";
import {ListaTarefa} from "../../../models/lista-tarefa";
import {Token} from "../../../../auth/models/token";
import {AuthService} from "../../../../auth/services/auth-service";
import {NovoCompromissoComponent} from "../../../agenda/componentes/novo-compromisso/novo-compromisso.component";
import {ToastrService} from "ngx-toastr";
import {error} from "@angular/compiler-cli/src/transformers/util";
import {DetalhesTarefasComponent} from "../../../../../core/componentes/detalhes-tarefas/detalhes-tarefas.component";

@Component({
    selector: 'app-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent {
  @ViewChild(NovoCompromissoComponent) novoCompromissoComponent: NovoCompromissoComponent;
  @ViewChild(DetalhesTarefasComponent) detalhesTarefasComponent: DetalhesTarefasComponent;
  loading = true;
  public colunas = [`Id`, `Descrição`, 'Responsável', 'Tipo tarefa', 'Data Finalização Prevista','Data de Cadastro'];
  public linhas: any[] = [];
  public listaTarefas = new ListaTarefa();
  public listaTarefasPlanejamento = new ListaTarefa();
  public listaTarefasFazer = new ListaTarefa();
  public listaTarefasEmAndamento = new ListaTarefa();
  public listaTarefasVerificacao = new ListaTarefa();
  public listaTarefasFechada = new ListaTarefa();
  token: Token | undefined;
  showModalDetalhes = false;

  constructor(private tarefaService: TarefaService,
              private toastr: ToastrService,
              private tokenService: AuthService) {
    this.buscarLista();
    this.token = this.tokenService.AccessToken;
  }



  public showModalNovo(): void {
    this.novoCompromissoComponent.abrirModal();
  }

  public fecharModalDetalhes(): void {
    this.showModalDetalhes = false;
  }

  public buscarDetalheTarefa(id: number){
    this.showModalDetalhes = true;
    this.detalhesTarefasComponent.buscarTarefaPorId(id);
  }

  public buscarLista(){
    this.tarefaService.minhasTarefas().subscribe(response => {
      if(response.sucesso){
        this.listaTarefas = response.dados;
        this.listaTarefasPlanejamento.itens = this.listaTarefas.itens.filter(x => x.status == 0);
        this.listaTarefasFazer.itens = this.listaTarefas.itens.filter(x => x.status == 1);
        this.listaTarefasEmAndamento.itens = this.listaTarefas.itens.filter(x => x.status == 2);
        this.listaTarefasVerificacao.itens = this.listaTarefas.itens.filter(x => x.status == 3);
        this.listaTarefasFechada.itens = this.listaTarefas.itens.filter(x => x.status == 4);
      }
    });
    this.loading = false;
  }

  // Variáveis para drag and drop
  private draggedItem: any = null;

  // Método chamado quando o usuário começa a arrastar um item
  public onDragStart(event: DragEvent, item: any): void {
    this.draggedItem = item;
    if (event.dataTransfer) {
      event.dataTransfer.setData('text/plain', item.id.toString());
      event.dataTransfer.effectAllowed = 'move';

      // Impedir que o card fique transparente durante o drag
      const draggedElement = event.target as HTMLElement;
      if (draggedElement) {
        // Usar o elemento original como imagem de drag para manter a aparência original
        event.dataTransfer.setDragImage(draggedElement, 0, 0);
      }
    }
  }

  // Método chamado quando o usuário arrasta um item sobre uma coluna
  public onDragOver(event: DragEvent, status: number): void {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
  }

  // Método chamado quando o usuário solta um item em uma coluna
  public onDrop(event: DragEvent, status: number): void {
    event.preventDefault();
    if (!this.draggedItem || this.draggedItem.status === status) {
      return;
    }

    // Atualiza o status da tarefa e move o card para a coluna correta
    this.atualizarStatusTarefa(this.draggedItem.id, status);
  }

  // Método para atualizar o status da tarefa
  private atualizarStatusTarefa(tarefaId: number, novoStatus: number): void {
    const tarefa = this.listaTarefas.itens.find(t => t.id === tarefaId);
    if (tarefa) {
      tarefa.status = novoStatus;
      this.atualizarListasLocalmente();
      this.tarefaService.buscarPorId(tarefaId).subscribe(response => {
        if (response.sucesso && response.dados) {
          const atribuiTarefa = {
            id: tarefaId,
            responsavelId: response.dados.responsavelId,
            status: novoStatus
          };

          this.tarefaService.alterarStatus(atribuiTarefa).subscribe(alterarResponse => {
            if (alterarResponse.sucesso) {
              this.toastr.success('Status da tarefa atualizado com sucesso');
            } else {
              this.toastr.error('Erro ao atualizar status da tarefa:', alterarResponse.errors[0].mensagem);
              this.buscarLista(); // Recarrega apenas em caso de erro
            }
          });
        } else {
          this.toastr.error('Erro ao atualizar status da tarefa');
          this.buscarLista(); // Recarrega apenas em caso de erro
        }
      });
    }
  }

  // Método para atualizar as listas localmente sem fazer chamada ao servidor
  private atualizarListasLocalmente(): void {
    this.listaTarefasPlanejamento.itens = this.listaTarefas.itens.filter(x => x.status == 0);
    this.listaTarefasFazer.itens = this.listaTarefas.itens.filter(x => x.status == 1);
    this.listaTarefasEmAndamento.itens = this.listaTarefas.itens.filter(x => x.status == 2);
    this.listaTarefasVerificacao.itens = this.listaTarefas.itens.filter(x => x.status == 3);
    this.listaTarefasFechada.itens = this.listaTarefas.itens.filter(x => x.status == 4);
  }
}
